import { NOTIFICATION_DISMISS } from '../constants/notification';
import { logout } from '../actions/auth';

const logoutMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  if (action.type === NOTIFICATION_DISMISS) {
    let index = getState().notifications.findIndex(
      (item) => item.id === action.id
    );
    let notification = getState().notifications[index];
    if (notification && notification.logoutOnClose) {
      dispatch(logout());
    }
  }

  return next(action);
};

export default logoutMiddleware;
